import { Download } from '@mui/icons-material';
import { Button, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { format, parse, parseISO } from 'date-fns';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../helpers/batchStatus';
import { clearOrders } from '../state/actions/orders';
import { fetchCustomerOrderLastReport, fetchLastReport, fetchOrderLastReport } from '../state/handlers/document';
import { fetchCustomerOrders, fetchOrders } from "../state/handlers/orders";
import { selectOrders } from '../state/selectors/orders';
import { selectProfile } from '../state/selectors/profile';


const Result = () => {

    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const isCustomer = profile.data?.role.code === 'customer';
    const customerId = profile.data?.customer?.id;

    
    useEffect(() => {
        return () => {
            dispatch(clearOrders);
        }
    }, []);

    useEffect(() => {

        if(isCustomer){
            dispatch(fetchCustomerOrders(customerId));
        }else{
            dispatch(fetchOrders());
        }
    }, [profile]);

    const handleDownload = (orderId) =>{
        if(isCustomer){
            dispatch(fetchCustomerOrderLastReport(customerId,orderId));
        }else{
            dispatch(fetchOrderLastReport(orderId));
        }
    };

    const columns = [
        {
            field: 'id',
            headerName: 'Id',
            width: 30,
            sortable: false,
            type: 'number',
            hide:true,
        },
        {
            field: 'batch_id',
            headerName: 'N° de pedido',
            sortable: false,
            type: 'string',
            width: 120,
        },
        {
            field: 'number',
            headerName: 'N° de procolo',
            sortable: false,
            flex: 0.5,
            minWidth: 110
        },
        {
            field: 'patient',
            headerName: 'Paciente',
            sortable: false,
            flex: 0.5,
            minWidth: 110,
            renderCell: (params) => params.row.patient && `${params.row.patient.last_name} ${params.row.patient.first_name}`,
        },
        {
            field: 'date',
            headerName: 'Fecha',
            sortable: false,
            flex: 0.5,
            valueGetter:(params)=>format(parseISO(params.value), 'dd/MM/yyyy'),
            minWidth: 110
        },
        {
            field: 'status',
            headerName: 'Estado',
            sortable: false,
            flex: 0.5,
            valueGetter:(params)=>translate(params.value),
            minWidth: 110
        },
        {
            field: 'download_result',
            headerName: 'Resultado',
            sortable: false,
            renderCell: (params) => (params.row.status === 'finished' || params.row.status === 'downloaded') && <Button  onClick={()=>handleDownload(params.row.id)} startIcon={<Download style={{color:'#696969'}}/>}/>,
        }

    ];

    const {loading, list} = useSelector(selectOrders);

    const data = {rows:list, columns:columns};

    const handleSelect = (order) => {
    };

    return ( 

        <div className="column-container all-height">
        <div className="header row-container align-center">
            <div>
                <Typography variant="h5" color="text.black">
                    <Box fontWeight={750}>Resultados</Box>
                </Typography>
            </div>
            <div className="grow"></div>
            <div className="grow margin">
                <TextField 
                    placeholder="Buscar" 
                    variant="standard" 
                    fullWidth
                    size="small"
                />
            </div>
        </div>

        <div className="body grow padding">
                <DataGridPro
                    {...data}
                    headerHeight={40}
                    rowHeight={40}
                    disableMultipleSelection
                    disableColumnMenu
                    disableColumnSelector
                    disableMultipleColumnsSorting
                    hideFooter
                    onCellClick={(params) => handleSelect(params.row)}
                />
        </div>
    </div>

     );
}
 
export default Result;